import React, { SetStateAction, useState } from "react";
import { ButtonBase } from "@reusejs/react";
import { XIcon } from "@heroicons/react/solid";

interface AadharMismatchModal {
  errorMessage: String;
  setModal: React.Dispatch<SetStateAction<boolean>>;
}
const AadharMismatchModal: React.FC<AadharMismatchModal> = ({
  setModal,
  errorMessage,
}) => {
  return (
    <div>
      (
      <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50 z-50">
        <div className="relative bg-white shadow-lg rounded-lg max-w-lg w-full">
          <h1 className="text-xl font-medium not-italic leading-6 text-gray-500 text-center w-full p-4 bg-red-200 border-b border-gray-500">
            Validation Failed!
          </h1>
          <div className="absolute top-4 right-4">
            <div
              className="cursor-pointer bg-gray-50 rounded-full p-1 border text-gray-900"
              onClick={() => setModal(false)}
            >
              <XIcon className="h-4 w-4" aria-hidden="true" />
            </div>
          </div>
          <div className="p-4">
            <div className="w-full border-gray-300 rounded-lg p-2 text-gray-500 text-center">
              {`The details in the Aadhar Card does not matches with the Bidder Application Form`}
            </div>
            <div>
              <div className="w-full border-gray-300 rounded-lg p-2 text-red-500 text-center">
                {`${errorMessage}`}
              </div>
            </div>
          </div>
        </div>
      </div>
      )
    </div>
  );
};

export default AadharMismatchModal;
